import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["src", "dummy", "fallback"],
  _excluded2 = ["src", "fallback"];
import React, { useState, useCallback } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
var cache = {};
export var Dummy = function Dummy(_ref) {
  var src = _ref.src,
    _ref$dummy = _ref.dummy,
    dummy = _ref$dummy === void 0 ? "/img/dummy-100.png" : _ref$dummy,
    _ref$fallback = _ref.fallback,
    fallback = _ref$fallback === void 0 ? null : _ref$fallback,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(!src || cache[src] === false),
    _useState2 = _slicedToArray(_useState, 2),
    hasError = _useState2[0],
    setHasError = _useState2[1];
  var errorHandler = useCallback(function () {
    cache[src] = true;
    setHasError(true);
  }, [src]);
  if (hasError && fallback) {
    return fallback;
  }
  return /*#__PURE__*/_jsx("img", _objectSpread(_objectSpread({}, props), {}, {
    onError: errorHandler,
    src: hasError ? dummy : src
  }));
};

/**
 * Image tag that can show a fallback image if the original one can't be
 * loaded.
 * @param {{
 *  src: string
 *  fallback?: string
 *  [key: string]: any
 * }} props
 */
var Image = function Image(_ref2) {
  var src = _ref2.src,
    fallback = _ref2.fallback,
    props = _objectWithoutProperties(_ref2, _excluded2);
  var _useState3 = useState(src),
    _useState4 = _slicedToArray(_useState3, 2),
    source = _useState4[0],
    setSource = _useState4[1];
  var handleError = function handleError() {
    return fallback && setSource(fallback);
  };
  return /*#__PURE__*/_jsx("img", _objectSpread({
    src: source,
    onError: handleError
  }, props));
};
export default Image;
//# sourceMappingURL=Image.js.map